var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"ResumeView",attrs:{"fluid":""}},[_c('iframe',{attrs:{"id":"resume","src":"/download/Peter David Hirschberg Resume.pdf","height":"100%","width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }